import { defineStore } from 'pinia'

import state from './state'
import getters from './getters'
import actions from './actions'

const useAnalyticsAdminStore = defineStore('analyticsAdmin', {
  state,
  getters,
  actions
})

export default useAnalyticsAdminStore
